import { MouseEvent, useState } from 'react';
import classNames from 'classnames';
import Link from '@alltrails/shared/denali/components/Link';
import PlusBadge from '@alltrails/shared/denali/components/PlusBadge';
import User from '@alltrails/shared/types/User';
import { FilterConfig, FilterViewModel } from 'types/Search';
import FilterInputFactory from 'components/explore/filters/FilterInputFactory';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import * as styles from './styles/styles.module.scss';

type Props = {
  className?: string;
  filter: FilterViewModel;
  hasDividerBars?: boolean;
  hasPlus?: boolean;
  onChange: (changes: FilterConfig) => void;
  shouldTruncate?: boolean;
  title: string;
  user?: User;
};

const ExpandableFilterPanel = ({
  className,
  filter,
  hasDividerBars = false,
  hasPlus = false,
  onChange,
  shouldTruncate = false,
  title,
  user
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = (e: MouseEvent) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };

  const getShowMoreContent = () => (
    <Link className={styles.showMore} onClick={toggleExpanded} size="md" testId="show-more">
      {isExpanded ? <FormattedMessage defaultMessage="Show less" /> : <FormattedMessage defaultMessage="Show more" />}
    </Link>
  );

  const truncate = !isExpanded && shouldTruncate;

  const truncatingFilters = () => {
    const f = { ...filter };
    // @ts-ignore
    f.config = Object.fromEntries?.(Object.entries(filter?.config)?.slice(0, 6));
    return { ...f };
  };

  const truncatedFilters = !isExpanded && filter.truncate ? truncatingFilters() : filter;
  return (
    <div className={classNames(styles.container, { [styles.dividerBars]: hasDividerBars }, className)}>
      {title && (
        <div className={styles.titleContainer}>
          {hasPlus ? <PlusBadge className={styles.plusBadge} /> : null}
          <div className={styles.title}>{title}</div>
        </div>
      )}
      <div className={classNames(styles.body, { [styles.truncate]: truncate })}>
        <span>
          <FilterInputFactory filter={truncatedFilters} onChange={onChange} user={user} />
        </span>
      </div>
      {shouldTruncate ? getShowMoreContent() : ''}
    </div>
  );
};

export default ExpandableFilterPanel;
